<template>
  <div class="build-portafolios-container margin-general">
    <div class="items-container">
      <div class="title-container">
        <div class="card">
          <h2 class="title">
            {{ $t("trading.buildPortafolio.title") }}
          </h2>
          <p class="sub-title body-4">
            {{ $t("trading.buildPortafolio.subTitle") }}
          </p>
          <NuxtLink :to="localPath('/trading/markets')" class="second-button-medium body-6-bold">
              {{ $t("trading.buildPortafolio.button") }}
          </NuxtLink>
        </div>
      </div>
      <div class="items-container-2">
        <div
          class="build-portafolio"
          v-for="(item, index) in advantages"
          :key="index"
        >
          <div class="image-container">
            <span class="material-symbols-outlined icon" translate="no">{{ item.image }}</span>
          </div>
          <div class="build-portafolio-text-item">
            <p class="title body-6-bold">{{ $t(item.title) }}</p>
            <p class="description body-4">{{ $t(item.description) }}</p>
          </div>
        </div>
      </div>
      <NuxtLink
        :to="localPath('/trading/markets')"
        style="text-decoration: none; z-index: 1"
        class="second-button-extrasmall"
      >
          {{ $t("unleash.explore") }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const localPath = useLocalePath();

const advantages = ref([
  {
    image: "currency_exchange",
    alt: "currency_exchange",
    iconSrc: "currency_exchange",
    title: "trading.buildPortafolio.forexT",
    description: "trading.buildPortafolio.forex",
  },
  {
    image: "monitoring",
    alt: "monitoring",
    iconSrc: "monitoring",
    title: "trading.buildPortafolio.stocksT",
    description: "trading.buildPortafolio.stocks",
  },
  /* {
    image: "handshake",
    alt: "handshake",
    iconSrc: "handshake",
    title: "trading.buildPortafolio.futuresT",
    description: "trading.buildPortafolio.futures",
  }, */
  {
    image: "oil_barrel",
    alt: "oil_barrel",
    iconSrc: "oil_barrel",
    title: "trading.buildPortafolio.commoditiesT",
    description: "trading.buildPortafolio.commodities",
  },
  {
    image: "finance_mode",
    alt: "finance_mode",
    iconSrc: "finance_mode",
    title: "trading.buildPortafolio.indicesT",
    description: "trading.buildPortafolio.indices",
  },
]);

const activeIndex = ref(null);

const toggleAccordion = (index) => {
  if (activeIndex.value === index) {
    activeIndex.value = null;
  } else {
    activeIndex.value = index;
  }
};
</script>